import { useQuery } from "@apollo/client";
import { PlatformEditQuery, PlatformShowQuery } from "../graphql/queries";

/**
 * Хук для загрузки одной платформы (для просмотра)
 */
export function usePlatformShowQuery(id: string | null, skip = false) {
  return useQuery(PlatformShowQuery, {
    variables: { id },
    skip: skip || !id,
  });
}

/**
 * Хук для загрузки платформы для редактирования
 */
export function usePlatformEditQuery(id: string | null, skip = false) {
  return useQuery(PlatformEditQuery, {
    variables: { id },
    skip: skip || !id,
  });
}
